import React, { useState, useRef, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import Webcam from "react-webcam";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const videoConstraints = {
  width: 220,
  height: 200,
  facingMode: FACING_MODE_USER,
};

function WebcamCapture({ showModal, setShowModal, image, setImage, ...rest }) {
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const webcamRef = useRef(null);

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  const handleCapture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc, rest);
  }, [setImage, rest]);

  const handleChangeMode = useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER ? FACING_MODE_ENVIRONMENT : FACING_MODE_USER
    );
  }, []);

  const handleClose = (e) => {
    e.preventDefault();
    setShowModal((show) => !show);
    if (!image) setImage("", rest);
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-60w"
    >
      <Modal.Body>
        <div className="webcam-container">
          <div className="webcam-img">
            {!image ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={"100%"}
                videoConstraints={{
                  ...videoConstraints,
                  facingMode,
                }}
              />
            ) : (
              <img src={image} alt="Document" />
            )}
          </div>
          <div className="mt-2 text-center">
            {image ? (
              <>
                <button
                  type="button"
                  className="btn btn-success mx-2"
                  onClick={() => setImage("")}
                >
                  Retake
                </button>
                <button
                  type="button"
                  className="btn btn-warning mx-2"
                  onClick={handleClose}
                >
                  Close
                </button>
              </>
            ) : (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button type="button" className="btn btn-success" onClick={handleCapture}>
                  Capture
                </button>
                <button
                  type="button"
                  className="btn btn-warning mx-2"
                  onClick={handleClose}
                >
                  Close
                </button>
                {isMobile && (
                  <button
                    type="button"
                    onClick={handleChangeMode}
                    className="btn btn-secondary"
                  >
                    Switch Camera
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default WebcamCapture;
